import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { selectCombinedFilter } from 'selectors/super-admin';
import { filterSelector } from 'selectors';

// Untyped .js component (resolves as `any`); it is a passthrough target here.
import FjSortTable from './fj-sort-table';

// Props are forwarded verbatim to the underlying (untyped) FjSortTable.
type ConnectedFjSortTableProps = Record<string, unknown>;

const ConnectedFjSortTable = (props: ConnectedFjSortTableProps): React.ReactElement => {
  const basicFilter = useSelector(filterSelector);
  const superFilter = useSelector(selectCombinedFilter);
  const theme = useTheme();

  const [filter, setFilter] = useState({ basicFilter, superFilter });

  useEffect(() => {
    setFilter({ basicFilter, superFilter });
  }, [basicFilter, superFilter]);

  return <FjSortTable filter={filter} theme={theme} {...props} />;
};

export default ConnectedFjSortTable;
